import { typedFrontendGalleryApi } from "@customer-gallery/utils/typedFrontendGalleryApi";
import { getAuthLink } from "@customer-gallery/utils/getAuthLink";
import { ICryptoWallet } from "@novel/shared/interfaces/CryptoWallet";
import { AuthWallet, WalletProviderType } from "@novel/shared/utils/wallets/AuthWallet";
import { MintingWallet } from "@novel/shared/utils/wallets/MintingWallet";

export class GalleryAuthWallet extends AuthWallet {
    constructor(walletProvider: WalletProviderType | ICryptoWallet) {
        super(walletProvider, getAuthLink);
    }
}

export class GalleryMintingWallet extends MintingWallet {
    constructor(walletProvider: ICryptoWallet) {
        super(typedFrontendGalleryApi, walletProvider, getAuthLink);
    }
}
